import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { WAITING_PAGE } from '@/Router/routes';

export default function KeycloakLoginConfirm() {
  const navigate = useNavigate();
  useEffect(() => {
    sessionStorage.setItem('token', 'kc');
    navigate(WAITING_PAGE, {
      state: {
        from: 'Keycloak',
      },
    });
  }, []);
  return null;
}
